// no imports!

export const TITLE = "Infinite Ascent";
export const DESCRIPTION =
  "Writing and blog posts by CJ Quines, about life, math, design, code, whatever.";
export const SITE_URN = "blog.cjquines.com";
export const SITE_URL = `https://${SITE_URN}`;
export const SUBSCRIBE_URL =
  "https://cjquines.aweb.page/p/0a2d21f0-276f-42a1-87d2-c9bf8b345386";
